export enum IdentificationDocumentCode {
  // International Documents
  Passport = 'PASSPORT',
  // Chilean Documents
  CL_RUT = 'CL_RUT',
}
